import { Dispatch } from 'redux';
import { HrpsApiClient } from '../../clients';
import { Logger } from '../../utils/logger';
import { ShipmentTrackingDetail } from '../types/trackingDetails';
import {
    RETURN_ORDER_TRACKING_CLEAR,
    RETURN_ORDER_TRACKING_GET,
    RETURN_ORDER_TRACKING_LOADED,
    ReturnOrderTrackingActions,
} from './returnOrderTrackingActions';

export function getReturnOrderTrackingLoading(): ReturnOrderTrackingActions {
    return {
        type: RETURN_ORDER_TRACKING_GET,
        payload: {
            status: 'Loading',
            error: undefined,
            value: undefined,
        },
    };
}

export function getReturnOrderTrackingLoaded(trackingDetails: ShipmentTrackingDetail[]): ReturnOrderTrackingActions {
    return {
        type: RETURN_ORDER_TRACKING_LOADED,
        payload: {
            status: 'Loaded',
            error: undefined,
            value: trackingDetails,
        },
    };
}

export function getReturnOrderTrackingFailed(error: any): ReturnOrderTrackingActions {
    return {
        type: RETURN_ORDER_TRACKING_LOADED,
        payload: {
            status: 'Failed',
            error,
            value: undefined,
        },
    };
}

export function getReturnOrderTrackingClear(): ReturnOrderTrackingActions {
    return {
        type: RETURN_ORDER_TRACKING_CLEAR,
        payload: {
            status: 'Uninitialized',
            error: undefined,
            value: undefined,
        },
    };
}

export function getReturnOrderTracking(returnOrderId: string, resellerId: string) {
    return async (dispatch: Dispatch) => {
        dispatch(getReturnOrderTrackingLoading());
        const hrpsApiClient = new HrpsApiClient();

        return hrpsApiClient
            .getTrackingDetails({
                returnOrderId,
                resellerId,
            })
            .then((response) => {
                dispatch(getReturnOrderTrackingLoaded(response.shipmentTrackingList));
            })
            .catch((error) => {
                Logger.debug(`error getting Tracking Details: ${error}`);
                dispatch(getReturnOrderTrackingFailed(error));
            });
    };
}
